import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import Layout from '../components/layout/Layout';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { ArrowLeft, FileText } from 'lucide-react';
import LoadingSpinner from '../components/common/LoadingSpinner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const LegalPage = ({ pageType, title }) => {
  const [content, setContent] = useState('');
  const [lastUpdated, setLastUpdated] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchContent();
  }, [pageType]);

  const fetchContent = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API}/pages/legal/${pageType}`);
      setContent(response.data.content || '');
      setLastUpdated(response.data.last_updated);
    } catch (error) {
      console.error('Error fetching legal page:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Layout>
        <div className="flex justify-center items-center min-h-[400px]">
          <LoadingSpinner />
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="max-w-4xl mx-auto">
        <Link to="/dashboard">
          <Button variant="ghost" className="mb-4">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Dashboard
          </Button>
        </Link>

        <Card className="overflow-hidden">
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-2xl">
              <FileText className="w-6 h-6 text-[#0A7EA4]" />
              {title}
            </CardTitle>
            {lastUpdated && (
              <p className="text-sm text-gray-500">
                Last updated: {new Date(lastUpdated).toLocaleDateString()}
              </p>
            )}
          </CardHeader>
          <CardContent className="overflow-hidden">
            {content ? (
              <div 
                className="legal-page-content"
                dangerouslySetInnerHTML={{ __html: content.replace(/&nbsp;/g, ' ') }}
              />
            ) : (
              <div className="text-center py-12 text-gray-500">
                <FileText className="w-12 h-12 mx-auto mb-4 opacity-50" />
                <p>This page content is being prepared.</p>
                <p className="text-sm mt-2">Please check back later.</p>
              </div>
            )}
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};

// Export specific page components
export const PrivacyPolicyPage = () => (
  <LegalPage pageType="privacy_policy" title="Privacy Policy" />
);

export const TermsOfUsePage = () => (
  <LegalPage pageType="terms_of_use" title="Terms of Use" />
);

export const RefundPolicyPage = () => (
  <LegalPage pageType="refund_policy" title="Refund Policy" />
);

export default LegalPage;
